<div class="filter-editor">
  <div class="filter-row" *ngFor="let row of rows; let i = index">
    <input type="text" placeholder="label (optional)" [(ngModel)]="row.name" (change)="emitFilters()" />
    <input type="text" placeholder="field path" [(ngModel)]="row.path" (change)="emitFilters()" />
    <select [(ngModel)]="row.type" (change)="emitFilters()">
      <option *ngFor="let type of types" [value]="type.key">{{type.name}}</option>
    </select>
    <input *ngIf="hasValue(row.type)" type="text" class="value-input"
      placeholder="value (JSON for ranges/lists, e.g. {&quot;min&quot;:0} or [&quot;a&quot;,&quot;b&quot;])"
      [(ngModel)]="row.valueText" (change)="emitFilters()" />
    <button class="button remove-button" (click)="removeRow(i)">Remove</button>
  </div>

  <button class="button" (click)="addRow()">Add Filter</button>
</div>
